"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const checkIsTouch = () => {
  var _sessionStorage$getIt;
  return (_sessionStorage$getIt = sessionStorage.getItem("mco-touch")) !== null && _sessionStorage$getIt !== void 0 ? _sessionStorage$getIt : false;
};
var _default = exports.default = checkIsTouch;